// Google Maps link for a free-text venue. A pasted http(s) link is used as-is.
export function getMapsUrl(venue: string): string {
  const v = venue.trim();
  if (/^https?:\/\//i.test(v)) return v;
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(v)}`;
}
